import "./navbar.css";
import Logo  from "../../assets/avanish8.jpeg";
import data from "./data";


function Navbar() {

    return (
        <nav id="navBar">
            <div className="container nav__container">
               
                    <a href="#header"><h1 className="my_logo">AKB</h1></a>
                <ul className="nav__menu">
                    {
                data.map((item)=>{
                    return (<li key={item.id}><a href={item.link}>{item.title}</a></li>)
                })
            }
                </ul>
            </div>
        </nav>
    )
}

export default Navbar;